import { coursConstants as crs } from "../../../constants/cours";

const initialState = { loading: true, list: [], cours: null, avenant: null };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case crs.GET_COURS:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case crs.GET_COUR:
      return {
        ...state,
        loading: false,
        cours: payload,
      };
      case crs.GET_AVENANT:
        return {
          ...state,
          loading: false,
          cours: payload,
        };
    default:
      return state;
  }
}
